import React from "react";
import { BackgroundSVG } from "./BackgroundSVG";

function BackgroundCircle2() {
  return (
    <BackgroundSVG
      top={"10%"}
      right={"30%"}
      left={"0"}
      width="88"
      height="88"
      viewBox="0 0 88 88"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.21"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.0189038 43.939C0.0189038 19.6717 19.7098 -0.000394139 44.0001 -0.000394139C68.2898 -0.000394139 87.9807 19.6717 87.9807 43.939C87.9807 68.2057 68.2898 87.8778 44.0001 87.8778C19.7098 87.8778 0.0189038 68.2057 0.0189038 43.939Z"
        fill="#3DD47E"
      />
    </BackgroundSVG>
  );
}

export default BackgroundCircle2;
